import { render, staticRenderFns } from "./ObjectTranslation.vue?vue&type=template&id=ed1c91da&scoped=true&"
import script from "./ObjectTranslation.vue?vue&type=script&lang=js&"
export * from "./ObjectTranslation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1c91da",
  null
  
)

export default component.exports